const getDefaultLocalisationForJO = () => {
  return {
    lat: 48.872837,
    lng: 2.310265,
  };
};

export { getDefaultLocalisationForJO };
